/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Offset_TimecodeInputs */



/**
* | output |
* | --- |
* | "Offset Timecode" |
*
* @param {Shortcut_Keys_Name_Offset_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_offset_timecode = /** @type {((inputs?: Shortcut_Keys_Name_Offset_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Offset_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler le timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offset-Zeitcode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice temporale offset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смещение временного кода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de tiempo de desplazamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("偏移时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフセットタイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफ़सेट टाइमकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de tempo de deslocamento")
	return /** @type {LocalizedString} */ ("Offset Timecode")
});